import { Clapperboard, GraduationCap, MonitorPlay, Users } from 'lucide-react';
import Reveal from './Reveal';

const CONCERNS = [
  {
    icon: Clapperboard,
    question: 'I love films, but I don’t know where to start.',
    body: 'Filmmaking has dozens of departments, career paths and technical terms.',
    answer: 'Cynopsis gives you a structured starting point.',
  },
  {
    icon: GraduationCap,
    question: 'Do I really need film school?',
    body: 'Film school can be expensive, and committing to a whole career feels risky.',
    answer: 'Cynopsis lets you learn, explore and build skills before making a huge commitment.',
  },
  {
    icon: Users,
    question: 'I know I want to make films, but what do I actually do?',
    body: 'Watching tutorials isn’t the same as understanding filmmaking. You need to see how filmmakers think and make decisions.',
    answer: 'Cynopsis combines structured learning with practical filmmaking.',
  },
  {
    icon: MonitorPlay,
    question: 'I want to work in films, but I don’t know where I fit.',
    body: 'Director? Editor? Writer? Producer? Explore the craft before choosing your specialisation.',
    answer: 'Cynopsis helps you discover where you belong.',
  },
];

const PainPoints = () => (
  <section
    data-testid="pain-points-section"
    className="relative overflow-hidden bg-[#080808] py-20 md:py-28"
  >
    <div className="grid-fade pointer-events-none absolute inset-0" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <Reveal className="mx-auto mb-14 max-w-3xl text-center md:mb-16">
        <h2 className="display-heading text-3xl text-white sm:text-4xl lg:text-5xl">
          You’re not the only one who <em>feels lost.</em>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CONCERNS.map(({ icon: Icon, question, body, answer }, idx) => (
          <Reveal key={question} delay={idx * 0.09} className="h-full">
            <article
              data-testid={`pain-point-card-${idx}`}
              className="home-card flex h-full flex-col p-6 md:p-7"
            >
              <span className="mb-6 flex h-10 w-10 items-center justify-center rounded-md border border-white/10 bg-white/[0.03]">
                <Icon className="h-5 w-5 text-[#C8102E]" strokeWidth={1.5} />
              </span>

              <h3 className="mb-3 font-serif text-lg leading-snug text-white">{question}</h3>

              <p className="mb-6 text-sm leading-relaxed text-zinc-400">{body}</p>

              <p className="mt-auto text-sm font-medium leading-relaxed text-[#C8102E]">{answer}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default PainPoints;
